export default "__VITE_ASSET__oVLASWJQ__"